<div class="org-switcher" [class.org-switcher--wide]="view === 'unsynced'" (click)="$event.stopPropagation()">

  <!-- ======================= list ======================= -->
  <ng-container *ngIf="view === 'list'">
    <div class="org-switcher__head">
      <button mat-icon-button type="button" class="flip-rtl" id="btn_orgSwitcherBack" (click)="backToMenu.emit()">
        <icon name="chevron_left"></icon>
      </button>
      <h3 class="org-switcher__title">{{ 'preferredOrg.menu.title' | translate }}</h3>
    </div>

    <div class="org-switcher__section">{{ 'preferredOrg.menu.openNow' | translate }}</div>
    <div class="org-switcher__current">
      <span class="org-switcher__avatar org-switcher__avatar--current">{{ initialOf(currentOrganization) }}</span>
      <span class="org-switcher__body">
        <span class="org-switcher__name">
          {{ currentOrganization?.name }}
          <span class="offline-copy-badge" *ngIf="isPreferred(currentOrganization)">
            <icon name="offline_pin" width="12" height="12"></icon>{{ 'preferredOrg.offlineReadyBadge' | translate }}
          </span>
        </span>
        <span class="org-switcher__sub">{{ sublineKey(currentOrganization) | translate }}</span>
      </span>
      <icon name="check_circle" width="22" height="22" class="org-switcher__current-check"></icon>
    </div>

    <div class="org-switcher__section" *ngIf="otherOrganizations.length">
      {{ 'preferredOrg.menu.switchTo' | translate }}
    </div>
    <div class="org-switcher__rows">
      <button type="button" class="org-switcher__row" *ngFor="let org of otherOrganizations"
        [disabled]="!isOnline || switching" (click)="switchTo(org)">
        <span class="org-switcher__avatar">{{ initialOf(org) }}</span>
        <span class="org-switcher__body">
          <span class="org-switcher__name">
            {{ org.name }}
            <span class="offline-copy-badge" *ngIf="isPreferred(org)">
              <icon name="offline_pin" width="12" height="12"></icon>{{ 'preferredOrg.offlineReadyBadge' | translate }}
            </span>
          </span>
          <span class="org-switcher__sub">{{ sublineKey(org) | translate }}</span>
        </span>
        <icon name="arrow_forward" width="20" height="20" class="flip-rtl"></icon>
      </button>
    </div>

    <div class="org-switcher__note">
      <icon name="info" width="18" height="18"></icon>
      <div>
        <p [innerHTML]="'preferredOrg.menu.switchNote' | translate: { org: preferredName }"></p>
        <button type="button" class="org-switcher__link" id="btn_orgSwitcherExplain" (click)="showExplain()">
          {{ 'preferredOrg.menu.explainLink' | translate }}
        </button>
      </div>
    </div>

    <div class="org-switcher__foot">
      <div>{{ 'preferredOrg.menu.footerPreferred' | translate }} <strong>{{ preferredName }}</strong></div>
      <button mat-button color="primary" type="button" class="org-switcher__change" id="btn_orgSwitcherChange" (click)="showConfirm()">
        <icon name="sync_alt" width="16" height="16"></icon>{{ 'preferredOrg.menu.change' | translate }}
      </button>
    </div>
  </ng-container>

  <!-- ======================= explain ======================= -->
  <ng-container *ngIf="view === 'explain'">
    <div class="org-switcher__head">
      <button mat-icon-button type="button" class="flip-rtl" (click)="showList()">
        <icon name="chevron_left"></icon>
      </button>
      <h3 class="org-switcher__title">{{ 'preferredOrg.explain.title' | translate }}</h3>
    </div>

    <p class="org-switcher__lead">{{ 'preferredOrg.explain.lead' | translate }}</p>

    <div class="org-switcher__compare">
      <div class="org-switcher__compare-card org-switcher__compare-card--local">
        <div class="org-switcher__compare-head">
          <icon name="offline_pin" width="16" height="16"></icon>{{ 'preferredOrg.offlineReadyBadge' | translate }}
        </div>
        <div class="org-switcher__compare-sub">
          {{ 'preferredOrg.explain.oneOrganization' | translate: { org: preferredName } }}
        </div>
        <div class="org-switcher__compare-points">
          <div>{{ 'preferredOrg.explain.localPoint1' | translate }}</div>
          <div>{{ 'preferredOrg.explain.localPoint2' | translate }}</div>
          <div>{{ 'preferredOrg.explain.localPoint3' | translate }}</div>
        </div>
      </div>
      <div class="org-switcher__compare-card org-switcher__compare-card--server">
        <div class="org-switcher__compare-head">
          <icon name="cloud" width="18" height="18"></icon>{{ 'preferredOrg.explain.onlineOnly' | translate }}
        </div>
        <div class="org-switcher__compare-sub">{{ 'preferredOrg.explain.allOthers' | translate }}</div>
        <div class="org-switcher__compare-points">
          <div>{{ 'preferredOrg.explain.serverPoint1' | translate }}</div>
          <div>{{ 'preferredOrg.explain.serverPoint2' | translate }}</div>
          <div>{{ 'preferredOrg.explain.serverPoint3' | translate }}</div>
        </div>
      </div>
    </div>

    <div class="org-switcher__warn-note">
      <icon name="warning" width="18" height="18"></icon>
      <div>{{ 'preferredOrg.explain.changeWarning' | translate }}</div>
    </div>

    <div class="org-switcher__actions">
      <button mat-button color="primary" type="button" (click)="showList()">
        {{ 'preferredOrg.explain.backToOrganizations' | translate }}
      </button>
    </div>
  </ng-container>

  <!-- ======================= confirm ======================= -->
  <ng-container *ngIf="view === 'confirm'">
    <div class="org-switcher__confirm">
      <div class="org-switcher__confirm-head">
        <icon name="offline_pin" width="22" height="22"></icon>
        <h3 class="org-switcher__confirm-title">{{ 'preferredOrg.confirm.title' | translate }}</h3>
      </div>
      <p class="org-switcher__lead">{{ 'preferredOrg.confirm.lead' | translate }}</p>

      <div class="org-switcher__picks">
        <button type="button" class="org-pick" *ngFor="let org of changeCandidates"
          [class.org-pick--on]="org.keycloakOrgId === pendingKeycloakOrgId" (click)="pick(org)">
          <icon [name]="org.keycloakOrgId === pendingKeycloakOrgId ? 'radio_button_checked' : 'radio_button_unchecked'"
            width="20" height="20" class="org-pick__radio"></icon>
          <span class="org-pick__body">
            <span class="org-pick__name">{{ org.name }}</span>
            <span class="org-pick__sub">{{ 'preferredOrg.confirm.wouldSync' | translate }}</span>
          </span>
        </button>
      </div>

      <div class="org-switcher__warn-note org-switcher__warn-note--danger" *ngIf="pendingOrganization">
        <icon name="delete_sweep" width="18" height="18"></icon>
        <div [innerHTML]="'preferredOrg.confirm.removalWarning' | translate:
          { old: preferredName, target: pendingOrganization.name }"></div>
      </div>

      <div class="org-switcher__note org-switcher__note--flush" *ngIf="blockedByRecords && gate">
        <icon name="warning" width="18" height="18" class="org-switcher__note-warn-icon"></icon>
        <div>
          <p>{{ 'preferredOrg.confirm.blockedNote' | translate: { count: gate.summary.total } }}</p>
          <button type="button" class="org-switcher__link" id="btn_orgSwitcherViewRecords"
            *ngIf="userPermittedForPreferred" (click)="showUnsynced()">
            {{ 'preferredOrg.confirm.viewRecords' | translate }}
          </button>
          <span *ngIf="!userPermittedForPreferred">{{ 'preferredOrg.confirm.otherUsersPending' | translate }}</span>
        </div>
      </div>

      <div class="org-switcher__note org-switcher__note--flush" *ngIf="gateBlockReasonKey">
        <icon name="cloud_off" width="18" height="18" class="org-switcher__note-warn-icon"></icon>
        <div>{{ gateBlockReasonKey | translate }}</div>
      </div>

      <div class="org-switcher__actions">
        <button mat-button type="button" (click)="showList()">{{ 'preferredOrg.confirm.cancel' | translate }}</button>
        <span [matTooltip]="blockedByRecords ? ('preferredOrg.confirm.syncFirstTip' | translate)
          : (gateBlockReasonKey ? (gateBlockReasonKey | translate) : '')">
          <button mat-flat-button color="primary" type="button" id="btn_orgSwitcherApplyChange"
            [disabled]="!canApplyChange" (click)="applyChange()">
            {{ 'preferredOrg.confirm.changeAndSync' | translate }}
          </button>
        </span>
      </div>
    </div>
  </ng-container>

  <!-- ======================= unsynced ======================= -->
  <ng-container *ngIf="view === 'unsynced'">
    <div class="org-switcher__head">
      <button mat-icon-button type="button" class="flip-rtl" (click)="showConfirm()">
        <icon name="chevron_left"></icon>
      </button>
      <h3 class="org-switcher__title">{{ 'preferredOrg.unsynced.title' | translate }}</h3>
    </div>

    <p class="org-switcher__lead" [innerHTML]="'preferredOrg.unsynced.lead' | translate: { org: preferredName }"></p>

    <div class="org-switcher__loading" *ngIf="previewsLoading">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>

    <div class="unsynced-group" *ngFor="let group of previews">
      <div class="unsynced-group__title">
        {{ ('preferredOrg.entities.' + group.kind) | translate }} ({{ group.count }})
      </div>

      <div class="unsynced-group__grid" *ngIf="group.rows.length" [ngSwitch]="group.kind">
        <!-- Sales orders: Code | Order date | Customer | Net total | Status -->
        <table class="unsynced-group__table" *ngSwitchCase="'salesOrders'">
          <thead>
            <tr>
              <th>{{ 'preferredOrg.unsynced.columns.code' | translate }}</th>
              <th>{{ 'preferredOrg.unsynced.columns.orderDate' | translate }}</th>
              <th>{{ 'preferredOrg.unsynced.columns.customer' | translate }}</th>
              <th class="unsynced-group__num">{{ 'preferredOrg.unsynced.columns.netTotal' | translate }}</th>
              <th>{{ 'preferredOrg.unsynced.columns.status' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of group.rows">
              <td class="unsynced-group__code">{{ rowCode(group.kind, row) }}</td>
              <td>{{ rowDate(group.kind, row) | date: 'dd/MM/yyyy h:mm a' }}</td>
              <td>{{ row?.customer?.name || '—' }}</td>
              <td class="unsynced-group__num">{{ (row?.netTotal ?? 0) | number: '1.2-2' }}</td>
              <td><span class="unsynced-group__status">{{ rowStatus(row) }}</span></td>
            </tr>
          </tbody>
        </table>

        <!-- Cash transactions: Code | Date | Cash register | Type | Amount | Status -->
        <table class="unsynced-group__table" *ngSwitchCase="'cashTransactions'">
          <thead>
            <tr>
              <th>{{ 'preferredOrg.unsynced.columns.code' | translate }}</th>
              <th>{{ 'preferredOrg.unsynced.columns.date' | translate }}</th>
              <th>{{ 'preferredOrg.unsynced.columns.cashRegister' | translate }}</th>
              <th>{{ 'preferredOrg.unsynced.columns.type' | translate }}</th>
              <th class="unsynced-group__num">{{ 'preferredOrg.unsynced.columns.amount' | translate }}</th>
              <th>{{ 'preferredOrg.unsynced.columns.status' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of group.rows">
              <td class="unsynced-group__code">{{ rowCode(group.kind, row) }}</td>
              <td>{{ rowDate(group.kind, row) | date: 'dd/MM/yyyy h:mm a' }}</td>
              <td>{{ registerName(row) }}</td>
              <td>{{ cashTypeKey(row) | translate }}</td>
              <td class="unsynced-group__num">{{ (row?.amount ?? 0) | number: '1.2-2' }}</td>
              <td><span class="unsynced-group__status">{{ rowStatus(row) }}</span></td>
            </tr>
          </tbody>
        </table>

        <!-- Closures: Closure code | Cash register | Opening time | Status -->
        <table class="unsynced-group__table" *ngSwitchCase="'closures'">
          <thead>
            <tr>
              <th>{{ 'preferredOrg.unsynced.columns.closureCode' | translate }}</th>
              <th>{{ 'preferredOrg.unsynced.columns.cashRegister' | translate }}</th>
              <th>{{ 'preferredOrg.unsynced.columns.openingTime' | translate }}</th>
              <th>{{ 'preferredOrg.unsynced.columns.status' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of group.rows">
              <td class="unsynced-group__code">{{ rowCode(group.kind, row) }}</td>
              <td>{{ registerName(row) }}</td>
              <td>{{ closureOpeningTime(row) | date: 'dd/MM/yyyy h:mm a' }}</td>
              <td><span class="unsynced-group__status">{{ closureStatusKey(row) | translate }}</span></td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="unsynced-group__foot">
        <span *ngIf="group.rows.length">
          {{ 'preferredOrg.unsynced.showing' | translate: { shown: group.rows.length, total: group.count } }}
        </span>
        <!-- Cash transactions and closures have no list that can show local unsynced
             records; the preview above is where they are seen (product decision). -->
        <button type="button" class="org-switcher__link" *ngIf="group.kind === 'salesOrders'"
          (click)="viewAll(group.kind)">
          {{ 'preferredOrg.unsynced.viewAll' | translate }}
          <icon name="chevron_right" width="18" height="18" class="flip-rtl"></icon>
        </button>
      </div>
    </div>
  </ng-container>

  <!-- ======================= syncing ======================= -->
  <ng-container *ngIf="view === 'syncing'">
    <div class="org-switcher__confirm">
      <h3 class="org-switcher__confirm-title">
        {{ 'preferredOrg.syncing.title' | translate: { org: progress?.targetName } }}
      </h3>
      <p class="org-switcher__lead">
        {{ 'preferredOrg.syncing.lead' | translate: { current: currentOrganization?.name } }}
      </p>

      <app-preferred-org-progress [progress]="progress" [showRunInBackground]="true"
        (runInBackground)="runInBackground()"></app-preferred-org-progress>

      <div class="org-switcher__actions" *ngIf="progress?.errorKey">
        <button mat-button color="primary" type="button" (click)="dismissFailedChange()">
          {{ 'preferredOrg.explain.backToOrganizations' | translate }}
        </button>
      </div>
    </div>
  </ng-container>
</div>
